import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useOptions } from 'entities/pledgeEstateForm';

export const OtherOwnerRelationship: FC<IFieldFactoryProps> = (props) => {
  const { otherOwnerRelationship } = useOptions();
  const { type, isDisabled, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={otherOwnerRelationship}
      disabled={isDisabled}
    />
  );
};
